module.exports = __webpack_public_path__ + "static/media/Modelo-de-aquivo-adicao-em-massa.81379087.xlsx";